module.exports = __webpack_public_path__ + "static/img/arrow_right.c1cd4016.svg";